module.exports = __webpack_public_path__ + "static/media/wtfm.e5187252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/wtfm.jpg
// module id = 394
// module chunks = 0